import { Navigate, Route, Routes } from 'react-router-dom';
import { AppShell } from './components/AppShell';
import { AcademyPage } from './pages/AcademyPage';
import { DashboardPage } from './pages/DashboardPage';
import { LeadsPage } from './pages/LeadsPage';
import { ManagementPage } from './pages/ManagementPage';
import { ReconciliationPage } from './pages/ReconciliationPage';
import { StatusPage } from './pages/StatusPage';

export function App() {
  return (
    <Routes>
      <Route element={<AppShell />}>
        <Route index element={<DashboardPage />} />
        <Route path="oportunidades" element={<LeadsPage />} />
        <Route path="conciliacao" element={<ReconciliationPage />} />
        <Route path="academy" element={<AcademyPage />} />
        <Route path="integracoes" element={<StatusPage />} />
        <Route path="gestao" element={<ManagementPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}

